"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapFormContextToProps = void 0;

var classnames_1 = __importDefault(require("classnames"));

var react_1 = __importDefault(require("react"));

var baseProps_1 = __importDefault(require("../assets/baseProps"));

var fieldContext_1 = require("../channels/fieldContext");

var formContext_1 = require("../channels/formContext");

var isInvalid_1 = require("../channels/isInvalid");

var withStyles_1 = require("../decorators/withStyles");

var Text_1 = __importDefault(require("../Text/Text"));

var View_1 = __importDefault(require("../View/View"));

var Field_styles_1 = require("./Field.styles");

var FormField =
/** @class */
function (_super) {
  __extends(FormField, _super);

  function FormField() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Object.defineProperty(FormField.prototype, "isInvalid", {
    get: function get() {
      return !!this.props.errorMessage || !!this.props.fieldError;
    },
    enumerable: false,
    configurable: true
  });

  FormField.prototype.renderLabel = function () {
    var _a = this.props,
        label = _a.label,
        name = _a.name,
        compact = _a.compact;

    if (compact) {
      // В компактном режиме лейблы не выводим
      return;
    }

    if (!label) {
      return;
    }

    return react_1.default.createElement("div", {
      className: this.props.classes.label
    }, react_1.default.isValidElement(label) ? label : react_1.default.createElement(Text_1.default, {
      labelFor: name,
      mode: "label"
    }, label));
  };

  FormField.prototype.renderFooterElement = function (node, _a, textTestId) {
    var isError = _a.isError,
        isJSX = _a.isJSX;

    if (!isJSX) {
      return react_1.default.createElement(View_1.default, {
        testId: (isError ? 'error' : 'info') + "-footer-text",
        className: this.props.classes.error
      }, react_1.default.createElement(Text_1.default, {
        testId: textTestId,
        text: node,
        mode: "small",
        secondary: !isError,
        error: isError
      }));
    } // здесь нельзя прокидывать `className={this.props.classes.error}` потому что внутри node могут быть
    // свои собственные отступы


    return react_1.default.createElement(View_1.default, {
      testId: (isError ? 'error' : 'info') + "-footer-text"
    }, react_1.default.createElement("div", {
      "data-test-id": textTestId
    }, node));
  };

  FormField.prototype.render = function () {
    var _a;

    var _b = this.props,
        children = _b.children,
        errorMessage = _b.errorMessage,
        errorMessageCustomJSX = _b.errorMessageCustomJSX,
        errorMessageTestId = _b.errorMessageTestId,
        classes = _b.classes,
        info = _b.info,
        infoCustomJSX = _b.infoCustomJSX,
        infoTestId = _b.infoTestId,
        label = _b.label,
        name = _b.name,
        testId = _b.testId;
    var field = classes.field,
        compact = classes.compact;
    var isCompact = this.props.compact;
    var isInvalid = this.isInvalid;
    return react_1.default.createElement(isInvalid_1.BroadcastIsInvalid, {
      channelValue: isInvalid
    }, react_1.default.createElement(fieldContext_1.BroadcastFieldContext, {
      channelValue: {
        label: label,
        name: name,
        insideField: true
      }
    }, react_1.default.createElement(View_1.default, __assign({}, baseProps_1.default(this.props), {
      className: classnames_1.default(field, (_a = {}, _a[compact] = isCompact, _a)),
      testId: testId
    }), this.renderLabel(), react_1.default.createElement(View_1.default, null, children), errorMessage && this.renderFooterElement(errorMessage, {
      isError: true,
      isJSX: errorMessageCustomJSX
    }, errorMessageTestId), info && this.renderFooterElement(info, {
      isJSX: infoCustomJSX
    }, infoTestId))));
  };

  FormField = __decorate([formContext_1.withFormContext(mapFormContextToProps), withStyles_1.withStyles(Field_styles_1.styles)], FormField);
  return FormField;
}(react_1.default.PureComponent);

exports.default = FormField;

function mapFormContextToProps(_a) {
  var isCompact = _a.isCompact;
  return {
    compact: isCompact
  };
}

exports.mapFormContextToProps = mapFormContextToProps;